import React, { useState } from 'react';
import './Header.css';
import logo from '../../images/logo2.jpg'


const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="header">
      <nav className="header__nav container">
        <div className="header__logo">
          {/* <span className="material-icons header__logo-icon">security</span> */}
          <a href="#">
            <span className="header__logo-text">
              <img src={logo} alt='logo' className='logo' />
              <p> CyberLingo </p>
            </span>
          </a>
        </div>
        
        <div className={`header__menu ${isMenuOpen ? 'header__menu--open' : ''}`}>
          <a href="#how-to-play" className="header__link" onClick={() => setIsMenuOpen(false)}>How to Play</a>
          <a href="#about" className="header__link" onClick={() => setIsMenuOpen(false)}>About</a>
          <a href="#get-the-game" className="header__link" onClick={() => setIsMenuOpen(false)}>Store</a>
        </div>
        
        <button 
          className="header__toggle"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          <span className="material-icons">menu</span>
        </button>
      </nav>
    </header>
  );
};

export default Header;